import { useState, useEffect } from 'react';
import { chatService } from '../services/chatService';

export const useAgentAvailability = () => {
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(false);

  const checkAvailability = async () => {
    if (isChecking) return;
    
    setIsChecking(true);
    try {
      const available = await chatService.checkAvailability();
      setIsAvailable(available);
    } catch (error) {
      console.error('Failed to check agent availability:', error);
      setIsAvailable(false);
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    // Initial check
    checkAvailability();

    // Set up periodic checks every 30 seconds
    const interval = setInterval(checkAvailability, 30000);

    return () => clearInterval(interval);
  }, []);

  return {
    isAvailable,
    isChecking,
    checkAvailability,
  };
};
